import { useState } from "react"
import moment from "moment"
import 'moment/locale/ru' 

import { Popover } from "antd"
import Calendar from "react-calendar"
import "react-calendar" 

import { ISelectDate } from "./types"

moment.locale('ru')


/** Выбор даты из календаря */
export const SelectDate = ({ currentDate, children, placement = 'bottomRight', onSelect }: ISelectDate) => {
    const [open, setOpen] = useState(false)

    const getInitialDate = () => {
        if (!currentDate) return new Date()
        const parsed = moment(currentDate, "DD.MM.YYYY")
        return parsed.isValid() ? parsed.toDate() : new Date()
    }

    const handleChange = (value: any) => {
        const date = Array.isArray(value) ? value[0] : value
        
        if (date) {
            const formattedDate = moment(date).format("DD.MM.YYYY")
            onSelect(formattedDate) // Отправляем дату в Input
            setOpen(false) // Закрываем Popover
        }
    }

    return (
        <Popover
            content={
                <Calendar
                    locale="ru-RU"
                    value={getInitialDate()}
                    onChange={handleChange}
                    formatShortWeekday={(locale, date) => moment(date).format('dd')}
                />
            }
            arrow={{ pointAtCenter: true }}
            open={open}
            onOpenChange={setOpen} // Ant Design сам будет управлять открытием
            trigger="click"
            placement={placement}
            zIndex={1061}
            styles={{ root: { width: '250px' } }}
        >
            <div style={{ cursor: 'pointer' }}>
                {children}
            </div>
        </Popover>
    )
}